import status_factory from '../common/statuses_factory';
export default {
  ...status_factory(),
};
